<template>
    <div class="no-results-found">
        <img src="../assets/images/no_result.png" alt="no result found">
        <p class="headline-text">No results found</p>
        <p class="sub-headline-text">Try adjusting your search or filter to find what you're looking for.</p>
    </div>
</template>
<script>
export default {
  name: 'NoResultsFound',
};
</script>
<style lang="scss" scoped>
.no-results-found{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666D92;
    img{
        width: 168px;
        height: 105px;
        margin-bottom: 18px;
    }
    .headline-text{
        font-size: 16px;
        font-weight: 600;
        line-height: 19.2px;
        text-align: center;
    }
    .sub-headline-text{
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: center;
    }
}
</style>
